module.exports = __webpack_public_path__ + "img/newsletter.e732b521.svg";